import { type Cell, flexRender } from '@tanstack/react-table';
import { cn } from '@/utils/style';

interface TableCellProps<TData> {
  cell: Cell<TData, unknown>;
  index: number;
}

export function TableCell<TData>(props: TableCellProps<TData>) {
  const { cell, index } = props;
  const isFirst = index === 0;

  return (
    <td
      className={cn('p-4 border-t border-gray-200', {
        'border-l-2': !isFirst,
      })}
    >
      <div className="truncate min-w-0">
        {flexRender(cell.column.columnDef.cell, cell.getContext())}
      </div>
    </td>
  );
}
